import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  signal,
  computed,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';

export interface TimeSlot {
  value: string;
  label: string;
}

@Component({
  selector: 'app-time-slot-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './time-slot-selector.html',
  styleUrl: './time-slot-selector.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSlotSelectorComponent implements OnInit, OnChanges {
  @Input() timeSlots: TimeSlot[] = [];
  @Input() selectedTime: string | null = null;
  @Input() isLoading: boolean = false;
  @Input() primaryColor: string = '#2563eb';
  @Output() timeSelected = new EventEmitter<string>();

  timeSlotsSignal = signal<TimeSlot[]>([]);

  ngOnInit(): void {
    this.timeSlotsSignal.set(this.timeSlots || []);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['timeSlots']) {
      const newSlots = this.timeSlots || [];
      this.timeSlotsSignal.set([...newSlots]);
    }
  }

  selectTime(timeValue: string): void {
    this.timeSelected.emit(timeValue);
  }

  // Group time slots by period (morning, afternoon, evening)
  groupedByPeriod = computed(() => {
    const slots = this.timeSlotsSignal();
    const groups: { label: string; icon: string; slots: TimeSlot[] }[] = [];

    const morning: TimeSlot[] = [];
    const afternoon: TimeSlot[] = [];
    const evening: TimeSlot[] = [];

    slots.forEach(slot => {
      const hour = parseInt(slot.value.split(':')[0], 10);
      if (hour < 12) morning.push(slot);
      else if (hour < 17) afternoon.push(slot);
      else evening.push(slot);
    });

    if (morning.length > 0) {
      groups.push({
        label: 'Mañana',
        icon: 'M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z',
        slots: morning,
      });
    }
    if (afternoon.length > 0) {
      groups.push({
        label: 'Tarde',
        icon: 'M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z',
        slots: afternoon,
      });
    }
    if (evening.length > 0) {
      groups.push({
        label: 'Noche',
        icon: 'M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z',
        slots: evening,
      });
    }

    return groups;
  });

  slotsCount = computed(() => this.timeSlotsSignal().length);
}
